import React from "react";
import { Pie } from "react-chartjs-2";

const COLORS = ["#7099ED", "#B3CCFF", "#9DBDFF", "#E1E9FF", "#4058A2"];

const TotalStudentChart = ({ studentsByYear }) => {
  const years = Object.keys(studentsByYear);
  const dataValues = years.map(year => studentsByYear[year]);

  const data = {
    datasets: [
      {
        data: dataValues,
        backgroundColor: COLORS.slice(0, years.length),
        hoverBackgroundColor: COLORS.slice(0, years.length),
        borderWidth: 0,
      },
    ],
    labels: years,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <div style={{ height: 100 }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default TotalStudentChart;
